// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowPartialRotateLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-partial-rotate-left': IconArrowPartialRotateLeft;
    }
}

/**
 * The icon component for the 'arrowPartialRotateLeft' icon
 */
export class IconArrowPartialRotateLeft extends IconSvg {
    public constructor() {
        super(arrowPartialRotateLeft16X16);
    }
}

registerIconSvg('icon-arrow-partial-rotate-left', IconArrowPartialRotateLeft);
export const iconArrowPartialRotateLeftTag = 'nimble-icon-arrow-partial-rotate-left';
